export enum SiteAccessPermission {
  Everyone = 'everyone',
  Password = 'password_holders',
}
